
import "./Accordion.scss";

export const Accordion = ({ children }) => {
	return (
		<div className="up-accordion">
			{children}
		</div>
	);
};
